import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class FlyoutState extends BaseYcState {
  readonly currentIdForFlyout: string|number;
  readonly idsForFlyout: (string|number)[];
}
